<form [formGroup]="createOfferForm">
	<centric-form-item>
		<centric-form-label>{{ 'offer.ageRestriction.label' | translate }}</centric-form-label>
		<centric-form-control frontendRequiredInput>
			<centric-radio-group formControlName="ageRestrictionValue" [inline]="true">
				<centric-radio
					*ngFor="let type of getAgeRestrictionData()"
					[value]="mapToAgeRestriction(type)"
					[label]="type | translate"
					[ariaLabel]="type"
					[checked]="shouldCheckEntry(type)"
					(radioChange)="onRestrictionTypeChange('ageRestriction', $event)">
				</centric-radio>
			</centric-radio-group>
		</centric-form-control>
	</centric-form-item>

	<ng-container *ngIf="shouldDisplayOtherAgeField()">
		<centric-form-item>
			<centric-form-label>{{ 'offer.ageRestriction.otherLabel' | translate }}</centric-form-label>
			<centric-form-control>
				<windmill-input
					formControlName="ageRestrictionOtherValue"
					type="text"
					class="other-input-field"
					[maxLength]="2"
					[mask]="showDecimal"
					[placeholder]="'offer.ageRestriction.otherPlaceholder' | translate"
					[ariaLabel]="'offer.ageRestriction.otherPlaceholder'"
					(inputValueChanged)="onValueChanged($event)">
				</windmill-input>
			</centric-form-control>
		</centric-form-item>
	</ng-container>
</form>
